// src/api.js
import axios from 'axios';

// Use env when present, otherwise default to same-origin in production.
const baseURL =
  process.env.REACT_APP_API_BASE_URL && process.env.REACT_APP_API_BASE_URL.trim().length > 0
    ? process.env.REACT_APP_API_BASE_URL
    : '';

const api = axios.create({ baseURL });

export default api;